import {cancel, check, trial} from '@sail/icons/react/Icon';
import type {IconAsset} from '@sail/icons/types';

export type Variant = 'processing' | 'success' | 'failed';

export type VariantStyles = {
  icon: IconAsset;
  iconSize: string;
  iconColor: string;
  iconBackground: string;
};

export const VARIANT_STYLES: Record<Variant, VariantStyles> = {
  processing: {
    icon: trial,
    iconSize: '20px',
    iconColor: 'icon',
    iconBackground: 'offset',
  },
  success: {
    icon: check,
    iconSize: '23px',
    iconColor: 'feedback.success',
    iconBackground: 'feedback.success',
  },
  failed: {
    icon: cancel,
    iconSize: '20px',
    iconColor: 'feedback.critical',
    iconBackground: 'feedback.critical',
  },
};

export function getVariant(
  maxRelayRequestStatus: string | null,
  sessionState: string,
): Variant {
  if (
    maxRelayRequestStatus === 'failure' ||
    maxRelayRequestStatus === 'refund' ||
    sessionState === 'error' ||
    sessionState === 'failed'
  ) {
    return 'failed';
  }
  if (sessionState === 'fulfillment_complete') {
    return 'success';
  }
  return 'processing';
}
